module.exports = __webpack_public_path__ + "media/images/landing/bg/screens-company/06-875a5513774aedd819323ef3779db8cd.png";